module.exports = __webpack_public_path__ + "img/otp.85cb99d3.svg";